import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import mergeAuditioneesTabRouter2 from "./mergeAuditioneesTabRouter2";

function MergeAuditioneesTab2(props) {

  return (
    <TabTemplate 
      router={mergeAuditioneesTabRouter2}
      passData={props.passData}
    />
  )

}

export default MergeAuditioneesTab2;